module.exports = __webpack_public_path__ + "media/images/mobility/basket-61f01697e330cde8f95b2335fd2a4c08.svg";